import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

import { EditExpenseComponent } from '../edit-expense/edit-expense.component';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';

import { MatDialog } from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { Utils } from '../../../utils/utils';
import { Input } from '@angular/core';

import { RefDataService } from '../../services/context/ref-data.service';

@Component({
  selector: 'gp-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.scss']
})
export class ExpenseListComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;
  displayedColumns: string[];

  Expenses: any = [];
  SelectedExpenses: any = [];
  
  @Input('ViewMode') viewMode: string;
  //@Input('GoalType') goalType: fromModel.GOALTYPE;
  @Input('GoalId') goalId: string;
  @Output() Save: EventEmitter<any> = new EventEmitter();
  @Output() UpdateExpense: EventEmitter<any> = new EventEmitter();

  //dataSource;
  dataSource = new MatTableDataSource<any>(this.Expenses);
  selection = new SelectionModel<any>(true, []);

  goalType: fromModel.GOALTYPE;
  
  planExpenses: fromModel.Expense[];
  
  expenseTypesRef: fromModel.CodeValue[];
  expenseTypeMenuItems;
  
  isDataChanged = false;
  

  constructor(private contextService:ContextService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private dialog: MatDialog, 
    private refDataService: RefDataService,
    private appMonitoringService: AppMonitoringService) {      
  }

  ngOnInit(): void {
    if(this.viewMode==="SMALL"){      
      this.displayedColumns = ['select', 'expDesc', 'amount', 'actions'];
    } else {
      //this.displayedColumns = ['select', 'expDesc', 'goalDesc', 'owner', 'amount', 'growthType', 'startYr', 'endYr', 'actions'];      
      this.displayedColumns = ['select', 'expDesc', 'amount', 'growthType', 'startYr', 'endYr', 'actions'];      
    }
    this.populateExpenseList();
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  private populateAppData(appData: fromModel.IAppData){
    this.prepareExpenseMenu(); 
    if(appData && (appData.action===fromModel.DATA_ACTION.UPDATEEXPENSE
      || appData.action===fromModel.DATA_ACTION.ADDEXPENSE
      || appData.action===fromModel.DATA_ACTION.DELETEEXPENSE
      || appData.action===fromModel.DATA_ACTION.CREATEGOAL)){
      this.populateExpenseList();
    }
  }

  private populateExpenseList(){
    if(this.goalId){
      this.goalType = this.dataService.getGoalByGoalId(this.goalId).goalType;
      this.planExpenses = this.dataService.getAllExpensesByGoalId(this.goalId);
    } else {
      this.planExpenses = this.dataService.getAllExpenses();
    }
    let _expenses =  [];
    let expData;
    this.SelectedExpenses = [];
    if(this.planExpenses && this.planExpenses.length>0){
      this.planExpenses.forEach(exp => {
        expData = this.prepareExpenseData(exp);
        _expenses.push(expData);
        if(expData.isIncluded){
          this.SelectedExpenses.push(expData);
        } 
      });
    }
    this.Expenses = _expenses;
    this.dataSource = new MatTableDataSource<any>(this.Expenses);
    this.selection = new SelectionModel<any>(true, this.SelectedExpenses);
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "ExpenseListComponent-populateExpenseList", false);
  }

  private prepareExpenseData(expense: fromModel.Expense){
    
    let expDesc;
    let goal = this.dataService.getGoalByExpenseId(expense.expId);
    if(goal){
      expDesc = goal.goalDesc;
    }
    let data = {
      expId: expense.expId,
      goalDesc: expDesc,
      expDesc: expense.expDesc,
      owner: this.dataService.getPlanClientByClientId(expense.owner).clientname,
      growthType: expense.growthType,
      growthRate: expense.growthRate,
      startType: expense.amtPeriod[0].startType,
      startYr: expense.amtPeriod[0].startYr,
      endYr: expense.amtPeriod[0].endYr,
      endAge: expense.amtPeriod[0].endAge,      
      duration: expense.amtPeriod[0].duration,
      endType: expense.amtPeriod[0].endType,
      amount: expense.amtPeriod[0].amount,
      isIncluded: expense.isIncluded,
    }
    return data;
  }

  prepareExpenseMenu(){   

    let goal = this.dataService.getGoalByType(fromModel.GOALTYPE.LGY);
    if(goal){
      this.expenseTypeMenuItems = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses).filter(({code}) => code !== fromModel.EXPENSETYPE.LGY); ;      
    } else {
      this.expenseTypeMenuItems = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses);
    }   


    
  }

  addExpense(expenseType){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.ADDEXPENSE, expenseType)
  }
  
  editExpense(expenseId){
    //let expense: fromModel.Expense = this.dataService.getExpenseByExpenseId(expenseId);
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITEXPENSE, expenseId)
  }

  deleteExpense(expenseId, expenseDesc){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEEXPENSE,expenseId,expenseDesc);    
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.ADDEXPENSE: {
        let _goalId;
        if(!this.goalId){
          _goalId = 0;
        } else {
          _goalId = this.goalId;
        }
        const dialogRef = this.dialog.open(EditExpenseComponent, {
        width: '70%',
        height: '70%',
        data: {expType: parm1, goalId: _goalId},
        //data: expense,
        disableClose: true    
        }).afterClosed()
        .subscribe(result => {
          if(result && result.isSaved && result.expense && result.expense.isIncluded){
            //this.refreshExpense(result.expense);              
            this.UpdateExpense.emit();
          }
        });        
      break;
    }
      case fromModel.OPENDIALOGACTIONS.EDITEXPENSE: {
          let _goalId;
          if(!this.goalId){
            _goalId = 0;
          } else {
            _goalId = this.goalId;
          }
          const dialogRef = this.dialog.open(EditExpenseComponent, {
          width: '70%',
          height: '70%',
          data: {expenseId: parm1},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              this.UpdateExpense.emit();
            }
          });        
        break;
      }
      case fromModel.OPENDIALOGACTIONS.DELETEEXPENSE: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Expense, name: parm2}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            let exp = this.dataService.getExpenseByExpenseId(parm1);
            let goal = this.dataService.getGoalByExpenseId(parm1);
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEEXPENSE, "EditExpenseComponent-deleteExpense", {expense: exp, goalId: goal.goalId});
            this.dataService.savePlan();
            this.UpdateExpense.emit();         
          }
        });
        break;
      }       
    }
  }

  // refreshExpense(expense: fromModel.Expense){
  //     const _exp = this.Expenses.find(exp=> exp.expId === expense.expId);
  //     if(_exp){
  //       const _expPosition = this.Expenses.indexOf(_exp);
  //       let expData = this.prepareExpenseData(expense);
  //       this.Expenses[_expPosition] = expData;   
  //       this.dataSource = new MatTableDataSource<any>(this.Expenses);   
  //       if(expData.isIncluded){
  //         this.SelectedExpenses.push(expData);
  //       }  
  //       this.selection = new SelectionModel<any>(true, this.SelectedExpenses);
  //     }
    
  // }

  saveSelectedExpenses() {
      let selectedExpenses = [];
      this.selection.selected.forEach(s => selectedExpenses.push(s.expId));
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDEXPENSES, "ExpenseListComponent-saveSelectedExpenses", {expenses: selectedExpenses});
      this.dataService.savePlan();
      this.Save.emit();
      // if(this.viewMode==='SMALL'){
      //   this.UpdateExpense.emit();
      // }
      this.isDataChanged = false;
  }

  save(){
    this.dataService.savePlan();
    //this.UpdateExpense.emit();    
    this.isDataChanged = false;
    
  }

  updateSelectedExpensesInCache() {
    if(this.viewMode==='SMALL'){
      let selectedExpenses = [];
      this.selection.selected.forEach(s => selectedExpenses.push(s.expId));
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDEXPENSES, "ExpenseListComponent-updateSelectedExpensesInCache", {expenses: selectedExpenses, goalId: this.goalId});  
      this.UpdateExpense.emit();
    }
  }

  masterToggle() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      this.isDataChanged = true;
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));

      //this.updateSelectedExpensesInCache();
    }
  }

  selectionToggle(row){
    this.isDataChanged = true;
    this.selection.toggle(row);    
  }

  isAllSelected() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }

}
